var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"breadcrumb"},[_c('a-breadcrumb',[_c('a-breadcrumb-item',[_vm._v(_vm._s(_vm.catalogueMeta))]),_c('a-breadcrumb-item',[_vm._v(_vm._s(_vm.currentMeta))])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }